module.exports = __webpack_public_path__ + "img/illustrative-kiln-matrix.399144a7.svg";